import React, { useContext } from "react";
import { LiveAnnouncer, LiveMessenger } from "react-aria-live";

import Logger from "../../util/logger";
const logger = Logger("announce-provider");

export const AnnounceContext = React.createContext({} as AnnounceContextProps);
interface AnnounceProps {
  announcePolite(message: string, id?: string): void,
  announceAssertive(message: string, id?: string): void
}
interface AnnounceContextProps {
  addMessage(message: string, assertive?: boolean):void
}
/**
 * Function to fetch content for the announce provider
 */
const Content: React.FC<AnnounceProps> = ({ announcePolite, announceAssertive, children }) => {
  /**
   * Function to add announce message
   * @param {string} message - message to be announced
   * @param {string} assertive - message type
   */
  const addMessage = (message: string, assertive?: boolean): void => {
    if (message) {
      if (assertive) {
        logger.debug("announce assertive %s", message);
        announceAssertive(message);
      } else {
        logger.debug("announce polite %s", message);
        announcePolite(message);
      }
    }
  };

  return (
    <AnnounceContext.Provider value={{ addMessage }}>
      {children}
    </AnnounceContext.Provider>
  );
};

/**
 * The provider for announce context
 */
export const AnnounceProvider: React.FC = ({ children }) => (
  <LiveAnnouncer>
    <LiveMessenger>
      {({ announcePolite, announceAssertive }) => (
        <Content
          announcePolite={announcePolite}
          announceAssertive={announceAssertive}
        >
          {children}
        </Content>
      )}
    </LiveMessenger>
  </LiveAnnouncer>
);

export const useAnnounce = () => useContext(AnnounceContext);
